const calendarFormatters = new Map<string, Intl.DateTimeFormat>();
const dateWithYear = new Intl.DateTimeFormat("en-US", {
  timeZone: "UTC",
  month: "short",
  day: "numeric",
  year: "numeric",
});
const dateWithoutYear = new Intl.DateTimeFormat("en-US", {
  timeZone: "UTC",
  month: "short",
  day: "numeric",
});

export const DateOnly = {
  fromInstant(instant: string | Date, timezone: string): string {
    let formatter = calendarFormatters.get(timezone);
    if (!formatter) {
      formatter = new Intl.DateTimeFormat("en-US", {
        timeZone: timezone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
      calendarFormatters.set(timezone, formatter);
    }
    const parts = formatter.formatToParts(new Date(instant));
    const part = (type: Intl.DateTimeFormatPartTypes) => parts.find((p) => p.type === type)!.value;
    return `${part("year")}-${part("month")}-${part("day")}`;
  },
  format(date: string): string {
    return formatDate(date, true);
  },
  inTimezone(timezone: string) {
    return {
      format(date: string, options: { year?: "always" | "when-different" } = {}): string {
        const currentYear = DateOnly.fromInstant(new Date(), timezone).split("-")[0];
        const includeYear = options.year !== "when-different" || date.split("-")[0] !== currentYear;
        return formatDate(date, includeYear);
      },
    };
  },
};

function formatDate(date: string, includeYear: boolean): string {
  const [year, month, day] = date.split("-").map(Number);
  if (!year || !month || !day) return date;

  const value = new Date(0);
  value.setUTCFullYear(year, month - 1, day);
  return (includeYear ? dateWithYear : dateWithoutYear).format(value);
}
